(function () {
  'use strict';

  function initOrderForm(root) {
    if (!root || root.dataset.songOrderInitialized === 'true') return;
    root.dataset.songOrderInitialized = 'true';

    var variantsDataEl = root.querySelector('[data-song-variants]');
    var variants = [];
    try {
      variants = JSON.parse(variantsDataEl.textContent);
    } catch (e) {
      variants = [];
    }

    var currencyCode = root.dataset.currency || 'USD';
    function formatMoney(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: currencyCode,
        }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2) + ' ' + currencyCode;
      }
    }

    var form = root.querySelector('[data-song-order-form]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-song-step]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-song-step-dot]'));
    var prevBtn = root.querySelector('[data-song-prev]');
    var nextBtn = root.querySelector('[data-song-next]');
    var submitBtn = root.querySelector('[data-song-submit]');
    var progressLabel = root.querySelector('[data-song-progress-label]');
    var variantIdInput = root.querySelector('[data-song-variant-id]');
    var priceEl = root.querySelector('[data-song-price]');
    var totalEl = root.querySelector('[data-song-total]');
    var streamingCheckbox = root.querySelector('[data-song-streaming]');
    var errorEl = root.querySelector('[data-song-error]');

    var currentStep = 0;

    function showStep(index) {
      steps.forEach(function (step, i) {
        step.hidden = i !== index;
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        dot.classList.toggle('is-done', i < index);
      });
      if (progressLabel) {
        progressLabel.textContent = 'Adım ' + (index + 1) + ' / ' + steps.length;
      }
      if (prevBtn) prevBtn.hidden = index === 0;
      if (nextBtn) nextBtn.hidden = index === steps.length - 1;
      if (submitBtn) submitBtn.hidden = index !== steps.length - 1;
      currentStep = index;
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function stepIsValid(step) {
      var fields = step.querySelectorAll('[required]');
      for (var i = 0; i < fields.length; i++) {
        if (!fields[i].checkValidity()) {
          fields[i].reportValidity();
          return false;
        }
      }
      return true;
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (!stepIsValid(steps[currentStep])) return;
        if (currentStep < steps.length - 1) showStep(currentStep + 1);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (currentStep > 0) showStep(currentStep - 1);
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        if (i < currentStep) showStep(i);
      });
    });

    function getSelectedOptionValue(name) {
      var input = root.querySelector('[data-song-option="' + name + '"]:checked');
      return input ? input.value : null;
    }

    function findMatchingVariant() {
      var style = getSelectedOptionValue('style');
      var language = getSelectedOptionValue('language');
      var delay = getSelectedOptionValue('delay');

      return variants.find(function (variant) {
        return variant.option1 === style && variant.option2 === language && variant.option3 === delay;
      });
    }

    function updatePriceAndTotal() {
      var variant = findMatchingVariant();
      if (!variant) return;

      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);

      var total = variant.price;
      if (streamingCheckbox && streamingCheckbox.checked) {
        total += parseInt(streamingCheckbox.dataset.addonPrice, 10) || 0;
      }
      if (totalEl) {
        totalEl.textContent = formatMoney(total);
      }
    }

    root.querySelectorAll('[data-song-option]').forEach(function (input) {
      input.addEventListener('change', updatePriceAndTotal);
    });

    if (streamingCheckbox) {
      streamingCheckbox.addEventListener('change', updatePriceAndTotal);
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!stepIsValid(steps[currentStep])) return;

        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }

        var variant = findMatchingVariant();
        if (!variant) {
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.textContent = 'Bu kombinasyon şu anda mevcut değil. Lütfen seçimlerinizi kontrol edin.';
          }
          return;
        }

        var properties = {};
        form.querySelectorAll('[data-song-property]').forEach(function (field) {
          if ((field.type === 'radio' || field.type === 'checkbox') && !field.checked) return;
          if (field.name && field.value) {
            properties[field.dataset.songProperty] = field.value;
          }
        });

        var items = [
          {
            id: variant.id,
            quantity: 1,
            properties: properties,
          },
        ];

        if (streamingCheckbox && streamingCheckbox.checked && streamingCheckbox.dataset.addonVariantId) {
          items.push({
            id: parseInt(streamingCheckbox.dataset.addonVariantId, 10),
            quantity: 1,
          });
        }

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.dataset.originalLabel = submitBtn.dataset.originalLabel || submitBtn.textContent;
          submitBtn.textContent = 'Ekleniyor...';
        }

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) throw data;
              return data;
            });
          })
          .then(function () {
            window.location.href = window.Shopify.routes.root + 'cart';
          })
          .catch(function (error) {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = submitBtn.dataset.originalLabel;
            }
            if (errorEl) {
              errorEl.hidden = false;
              errorEl.textContent =
                (error && error.description) || 'Sepete eklerken bir hata oluştu.';
            }
          });
      });
    }

    var mainImage = root.querySelector('#SongOrderMainImage');
    root.querySelectorAll('[data-song-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImage) mainImage.src = thumb.dataset.fullSrc;
        root.querySelectorAll('[data-song-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });

    showStep(0);
    updatePriceAndTotal();
  }

  function initAll() {
    document.querySelectorAll('[data-song-order]').forEach(initOrderForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-song-order]');
    if (root) initOrderForm(root);
  });
})();
